import React, { createContext, useState, useEffect } from "react";
import { UsersServices } from "../services/UsersAPIs";

export const UserContext = createContext();

export const UserContextProvider = ({ children }) => {
    const { getUsers, getUserById, createUser, updateUserStatus, deleteUser } = UsersServices();

    // State
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState('');
    const [filters, setFilters] = useState({
        status: '',
        startDate: '',
        endDate: '',
    });

    // Fetch users with pagination, search, and filters
    const fetchUser = async (params = {}) => {
        setLoading(true);
        setError(null);
        try {
            const query = {
                page,
                limit,
                search,
                ...filters,
                ...params
            };
            const response = await getUsers(query);
            setUsers(response.data || []);
            setTotal(response.total || 0);
            return { success: true, data: response };
        } catch (err) {
            console.warn(err);
            setError(err);
            return { success: false, error: err };
        } finally {
            setLoading(false);
        }
    };

    const fetchUserById = async (id) => {
        try {
            const response = await getUserById(id);
            return { success: true, data: response };
        } catch (error) {
            console.warn(error);
            return { success: false, error };
        }
    }

    // Create or update user
    const userCreate = async (payload, isEdit) => {
        try {
            const response = await createUser(payload, isEdit);
            // await fetchUser();
            return { success: true, data: response };
        } catch (error) {
            console.warn(error);
            return { success: false, error };
        }
    };

    // create or update trainer
    const trainerCreate = async (payload, isEdit) => {
        try {
            const response = await createUser(payload, isEdit);
            return { success: true, data: response };
        } catch (error) {
            console.warn(error);
            return { success: false, error };
        }
    };

    // Update user status
    const updateStatus = async (id, payload) => {
        try {
            const response = await updateUserStatus(id, payload);
            // await fetchUser();
            return { success: true, data: response };
        } catch (error) {
            console.warn(error);
            return { success: false, error };
        }
    };

    // Delete user
    const userDelete = async (id) => {
        try {
            const response = await deleteUser(id);
            // await fetchUser();
            return { success: true, data: response };
        } catch (error) {
            console.warn(error);
            return { success: false, error };
        }
    };

    // Pagination helpers
    const handlePageChange = (newPage) => {
        setPage(newPage);
        fetchUser({ page: newPage });
    };

    const handleLimitChange = (newLimit) => {
        setLimit(newLimit);
        setPage(1);
        fetchUser({ page: 1, limit: newLimit });
    };

    const handleSearchChange = (searchText) => {
        setSearch(searchText);
        setPage(1);
        fetchUser({ page: 1, search: searchText });
    };

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        setPage(1);
        fetchUser({ page: 1, ...newFilters });
    };

    return (
        <UserContext.Provider
            value={{
                //
                fetchUser,
                userCreate,
                updateStatus,
                userDelete,
                fetchUserById,

                //values
                users,
                loading,
                error,
                total,
                page,
                limit,

                //
                handlePageChange,
                handleLimitChange,
                handleSearchChange,
                handleFilterChange
            }}
        >
            {children}
        </UserContext.Provider>
    );
};

// Custom hook to use the users context
export const useUsers = () => {
    const context = React.useContext(UserContext);
    if (context === undefined) {
        throw new Error("useUsers must be used within a UserContextProvider");
    }
    return context;
};
